__webpack_require__.p = "/skill-elearning-landing-page/";